// extracted by mini-css-extract-plugin
module.exports = {"recentWins":"_48bfbf6","recentTable":"_71d9ed5","player":"_d4165ca","prize":"_2a6bc77","replayButton":"_a515803","empty":"_bf9d83b"};